import Store, {history} from "../configureStore";
import {MY_TEAM_MEMBER_MANAGEMENT} from "../constants/urls";
import {UserManagementAction} from "../actions";

export const teamManagementHandle = () => {
  const notOwnedCount = Store.getState().Init.data.not_owned_management_count;
  if (notOwnedCount > 0) {
    Store.dispatch(UserManagementAction.showTeamManagementMenuModal());
  } else {
    history.push(MY_TEAM_MEMBER_MANAGEMENT);
  }
};
